import PropTypes from 'prop-types';

const googleAnalyticsShape = PropTypes.shape({
    onLoad: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onForceChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onResult: PropTypes.func.isRequired,
    onDetails: PropTypes.func.isRequired,
});

export default googleAnalyticsShape;



// WEBPACK FOOTER //
// ./src/frontend/components/googleAnalytics/googleAnalyticsShape.js